// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabsborder{
    border-bottom: none !important;
  }

.h6, h6 {
  font-size: 1rem;
}

:host ::ng-deep .tab-content{
  padding: 1rem;
}

:host ::ng-deep .layout_space{
  padding: 0%;
}

:host ::ng-deep .nav.nav-tabs.nav-underline .nav-item a.nav-link {
  padding: 0.5rem 0rem;
}
:host ::ng-deep .btn-outline-info .active {
  background: rgba(0, 0, 0, .05);
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImN1c3RvbWl6ZXIuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLDhCQUE4QjtFQUNoQzs7QUFFRjtFQUNFLGVBQWU7QUFDakI7O0FBRUE7RUFDRSxhQUFhO0FBQ2Y7O0FBRUE7RUFDRSxXQUFXO0FBQ2I7O0FBRUE7RUFDRSxvQkFBb0I7QUFDdEI7QUFDQTtFQUNFLDhCQUE4QjtBQUNoQyIsImZpbGUiOiJjdXN0b21pemVyLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIudGFic2JvcmRlcntcbiAgICBib3JkZXItYm90dG9tOiBub25lICFpbXBvcnRhbnQ7XG4gIH1cblxuLmg2LCBoNiB7XG4gIGZvbnQtc2l6ZTogMXJlbTtcbn1cblxuOmhvc3QgOjpuZy1kZWVwIC50YWItY29udGVudHtcbiAgcGFkZGluZzogMXJlbTtcbn1cblxuOmhvc3QgOjpuZy1kZWVwIC5sYXlvdXRfc3BhY2V7XG4gIHBhZGRpbmc6IDAlO1xufVxuXG46aG9zdCA6Om5nLWRlZXAgLm5hdi5uYXYtdGFicy5uYXYtdW5kZXJsaW5lIC5uYXYtaXRlbSBhLm5hdi1saW5rIHtcbiAgcGFkZGluZzogMC41cmVtIDByZW07XG59XG46aG9zdCA6Om5nLWRlZXAgLmJ0bi1vdXRsaW5lLWluZm8gLmFjdGl2ZSB7XG4gIGJhY2tncm91bmQ6IHJnYmEoMCwgMCwgMCwgLjA1KTtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/_layout/customizer/customizer.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;EAChC;;AAEF;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;;AAEA,o5BAAo5B","sourcesContent":[".tabsborder{\n    border-bottom: none !important;\n  }\n\n.h6, h6 {\n  font-size: 1rem;\n}\n\n:host ::ng-deep .tab-content{\n  padding: 1rem;\n}\n\n:host ::ng-deep .layout_space{\n  padding: 0%;\n}\n\n:host ::ng-deep .nav.nav-tabs.nav-underline .nav-item a.nav-link {\n  padding: 0.5rem 0rem;\n}\n:host ::ng-deep .btn-outline-info .active {\n  background: rgba(0, 0, 0, .05);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
